<template>

  <select-dropdown :ref="_uid" @onChange="onChange" />
  
</template>

<script>

  import SelectDropdown from "./select-dropdown.vue"

  export default {

    name: "SelectDay",
    
    components: {
      SelectDropdown,
    },

    mounted() {

      let days = []

      for (let day = 1; day <= 31; day++) {
        days.push({ id: day, value: day })
      }

      this.$refs[this._uid].setValues(days)
    },

    methods: {

      setSelected(day) {      
        this.$refs[this._uid].setSelected(day)
      },

      onChange(day) {
        this.$emit("onChange", day)
      },

      clear() {
        this.$refs[this._uid].clear()
      },

      reset() {
        this.$refs[this._uid].reset()
      },
    },
  }

</script>

